import React from "react";
import "../style/scholDescription.css";
import schoolImage from "./assests/schoolImage.png";
import image from "./assests/image.JPG";
import IMAGE from "./assests/IMAGE.png";

const SchoolDescription = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div >
            <img src={IMAGE} alt="heroImage" />
          </div>
        </div>
      </div>
      <div className="row mt-20">
        <div className="col-lg-4 col-md-6 col-sm-12">
          <div>
            <img src={schoolImage} class="about-us-img1" />
          </div>
        </div>
        <div className="col-lg-7 col-md-6 col-sm-12">
          <div class="">
            <h1 class="font-headerFont font-bold text-3xl text-[#8C1F1F] mb-6 mt-8">
              SCHOOL
            </h1>
            <p className="text-black text-xl font-semibold leading-">
              Our school is an institution designed to provide learning spaces
              and learning environments for the students under the guidance of
              the teachers.
            </p>
            <br />
            <br />
            <h1 class="font-headerFont font-bold text-3xl text-[#8C1F1F] mb-6">
              SCHOOL LIFE
            </h1>
            <p className="text-black text-xl font-semibold leading-8">
              “School life is the best life” and life is all about learning for
              something new & being innovative. Our school gives education,
              joyful life and creates healthy learning space for child about
              each different aspects of learning. Schooling is the most
              important part of a child’s life and it should be really free from
              the care and worries. Schools build the character of students.
              This is the formative period for students. Each and every student
              should try to make his/her life worthy and make best use of the
              time spent in school because it never comes again once the school
              sessions get completed.
            </p>
            <br />
          </div>
        </div>
      </div>
      <div className="row mt-10">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <h1 class="font-headerFont font-bold text-3xl mb-6 text-[#8C1F1F]">
            JUNIOR COLLEGE OF COMMERCE
          </h1>
          <p className="text-black text-xl font-semibold leading-8">
            Our junior college has well qualified and trained teachers to teach
            our adolescent students. Discipline is the key towards progress and
            our students consistently have given us good results at the State
            Board examinations because of their sense of discipline and
            dedication which is inculcated by our teachers. Individual coaching
            to the weak students is given as a part of the curriculum and all
            care is taken to help the needy students. We believe that the
            learning process must give happiness to the students. We also give
            them life skills.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolDescription;
